import { Component } from '@angular/core';
import { ATInternetService } from '@ff/at-internet';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterOutlet } from '@angular/router';
import { UserService } from '@ff/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  public constructor(
    public atInternet: ATInternetService,
    public translate: TranslateService,
    private snackbar: MatSnackBar,
    private userService: UserService,
  ) {

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    let user = this.userService.getUser().getValue();
    translate.use(user?.lang || 'en');
    translate.setDefaultLang(user?.lang || 'en');

  }
}
